import { forwardRef, Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ALGORITHM_BY_ID } from '../common/endpoints';
import { Algorithm } from '../model';
import { HttpService } from './http.service';


@Injectable()
export class AlgorithmService {

    constructor(
        @Inject(forwardRef(() => HttpService)) private http: HttpService
    ) { }

    getAlgorithmById(id: string): Promise<Algorithm> {
        return firstValueFrom(this.http.get<Algorithm>(ALGORITHM_BY_ID.replace("{id}", id)));
    }

}